import confetti from "canvas-confetti";

export type ConfettiOptions = {
  iterations?: number;
  delay?: number;
};

const randVal = (min = 0, max = 1): number => {
  return Math.random() * (max - min) + min;
};

const timeout = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export function showConfetti(params?: ConfettiOptions): void {
  const { iterations, delay } = {
    iterations: 3,
    ...params,
  };

  let runs = 0;
  async function run(): Promise<void> {
    if (iterations !== -1 && runs >= iterations) {
      return;
    }

    runs += 1;

    const angle = [75, 90, 105][runs % 3];
    const x = [0.2, 0.5, 0.8][runs % 3];

    confetti({
      disableForReducedMotion: true,
      spread: 120,
      particleCount: 240,
      origin: { x, y: randVal(0.3, 0.7) },
      angle,
    });

    await timeout(750);
    run();
  }

  if (delay) {
    timeout(delay).then(run);
  } else {
    run();
  }
}
